module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "part",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_vm._v("The Trong Troupe")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Trong Impresario")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Ambria Impresario, Trong’s second wife")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("K’linpor Actor, Trong’s son")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Halma Actor, K’linpor’s wife")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Uthiam Piper, Ambria’s daughter")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Golfren Piper, Uthiam’s husband")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Yama Actor, Ambria’s cousin")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Dolm Actor, Yama’s husband")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Piol Poet, brother of Ambria’s first husband")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Gartol Costumer, Trong’s cousin")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Olimmiar Dancer, Halma’s sister")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Klip Trumpeter, Gartol’s stepbrother")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Eleal Singer, an orphan")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91cbe292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PastImperative7.vue
// module id = 90
// module chunks = 0